import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin":"2%","font-weight":"bold"} }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table-transmission table-deductions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Descripción concepto"),
  /*#__PURE__*/_createElementVNode("th", null, "Concepto salarial"),
  /*#__PURE__*/_createElementVNode("th", null, "Concepto no salarial"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_5 = { class: "p-v-error error-transmission" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "p-v-error error-transmission" }
const _hoisted_8 = { class: "tooltip-container" }
const _hoisted_9 = { class: "p-v-error error-transmission" }
const _hoisted_10 = { class: "tooltip-container" }
const _hoisted_11 = { class: "delete-row" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.AgregarConcepto && $setup.AgregarConcepto(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'plus-circle'],
          style: {"color":"#00805d"}
        }),
        _createTextVNode(" Adicionar ")
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.otherConcepts.items, (concept, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: concept.Description,
                  "onUpdate:modelValue": ($event: any) => ((concept.Description) = $event),
                  class: _normalizeClass({
                'p-invalid':
                  $setup.v$.items.$each.$response.$errors[index].Description[0],
              })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                    .Description, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  min: 0,
                  inputId: "minmax-buttons",
                  mode: "currency",
                  currency: "COP",
                  locale: "es-CO",
                  modelValue: concept.Total,
                  "onUpdate:modelValue": ($event: any) => ((concept.Total) = $event),
                  maxFractionDigits: 0,
                  class: _normalizeClass(["pv-input-size input-number quantity", {
                'p-invalid': $setup.v$.items.$each.$response.$errors[index].Total[0],
              }])
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index].Total, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  min: 0,
                  inputId: "minmax-buttons",
                  mode: "currency",
                  currency: "COP",
                  locale: "es-CO",
                  maxFractionDigits: 0,
                  modelValue: concept.NonSalaryTotal,
                  "onUpdate:modelValue": ($event: any) => ((concept.NonSalaryTotal) = $event),
                  class: _normalizeClass(["pv-input-size input-number quantity", {
                'p-invalid':
                  $setup.v$.items.$each.$response.$errors[index].NonSalaryTotal[0],
              }])
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                    .NonSalaryTotal, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("a", {
                  onClick: ($event: any) => ($setup.EliminarConcepto(index))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'minus-circle'],
                    size: "lg"
                  })
                ], 8, _hoisted_12)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}